import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a53b0362cc250001481a3e0_1785691738159_16a2caf1/muyuride_1783869494387/src/app/browse-couriers/components/BrowseCouriersContent.tsx");
